import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F4255PartIService {

  constructor(private http: HttpClient) {}

  mapColIdToLetter(colId: string): string {
    if (!colId || colId.length < 2 || colId[0] !== '_') return '';
    const c = colId.charCodeAt(1);
    if (c >= 'a'.charCodeAt(0) && c <= 't'.charCodeAt(0)) {
      return String.fromCharCode(c - 'a'.charCodeAt(0) + 'A'.charCodeAt(0));
    }
    return '';
  }

  buildAmountDataClobData(data: { rowData?: any; col_id?: string; colData?: any; row_id?: any }): any[] | null {
    const rowData = data?.rowData || {};
    const colId = data?.col_id;
    if (!colId) return null;

    const colLetter = this.mapColIdToLetter(colId);
    if (!colLetter) return null;

    const lineNoStr = String(rowData.LINE_NO || '').trim();
    if (!lineNoStr) return null;

    // Sub-row suffix comes from LINE_NO (e.g. "2z" -> "Z"). Single-part lines like "3"
    // have no suffix and produce names such as F4255PI_LINE3A.
    const rowLetter = lineNoStr.length > 1 ? lineNoStr.substring(1).toUpperCase() : '';
    const lineNo = lineNoStr.charAt(0);
    const attribName = rowLetter
      ? `F4255PI_LINE${lineNo}${rowLetter}${colLetter}`
      : `F4255PI_LINE${lineNo}${colLetter}`;

    return [{
      combination_key: rowData.COMBINATION_KEY,
      acct_ref_key: rowData.ATTRIB_ACCT_REFERENCE_KEY,
      trans_details_key: rowData.TRANS_DETAILS_KEY,
      attrib_value: rowData[colId],
      attrib_name: attribName,
      description: data?.colData?.label ?? rowData.ATTRIB_DESCRIPTION,
      line_no: rowData.LINE_NO
    }];
  }

  loadJsonObject(baseUrl: string, params: Record<string, any>): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    return this.http.get<any>(`${url}?${urlEncoded.toString()}`, { withCredentials: true });
  }

  saveAmountData(
    baseUrl: string,
    clobData: any[],
    clobSettings: any[],
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=sh9ggd`;

    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ clob_data: JSON.stringify(clobData) }, params);
    params = _.extend({ clob_settings: JSON.stringify(clobSettings) }, params);
    params.process_name = '4255_SAVE_DATA';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
